import React, { useId } from 'react';
import P from '@hero/ui-kit/typography/P';
import { MarkChoice, MarkChoiceLabel } from '../../../components/MarkControls';
import type { SegmentMatch } from '../../../types';
import * as styles from './style.module.css';

type Props = { value: SegmentMatch; onChange: (value: SegmentMatch) => void };
const choices: { value: SegmentMatch; title: string; description: string }[] = [
    { value: 'ALL', title: 'Match all filters', description: 'Records must meet every condition.' },
    {
        value: 'ANY',
        title: 'Match any filter',
        description: 'Records only need to meet one condition.'
    }
];
const MatchToggle: React.FC<Props> = ({ value, onChange }) => {
    const groupId = useId();
    return (
        <div role="radiogroup" aria-label="Filter match mode" className={styles.matchGrid}>
            {choices.map((choice) => (
                <MarkChoiceLabel key={choice.value} htmlFor={`${groupId}-${choice.value}`}>
                    <MarkChoice
                        id={`${groupId}-${choice.value}`}
                        type="radio"
                        name={groupId}
                        value={choice.value}
                        checked={value === choice.value}
                        onChange={() => onChange(choice.value)}
                    />
                    <span>
                        <strong>{choice.title}</strong>
                        <P
                            noDefaultMargin
                            size="small"
                            styles={{ color: 'var(--mark-muted)', marginTop: '0.4rem' }}
                        >
                            {choice.description}
                        </P>
                    </span>
                </MarkChoiceLabel>
            ))}
        </div>
    );
};
export default MatchToggle;
